import styled from 'styled-components';

export const AlertContainer = styled.div`
	margin-bottom: 15px;
`;

export const stylePaddingCols: any = { paddingRight: '12px' };
